export type StageSelectTab = "catalog" | "custom";

export function StageSelectTabs({
  value,
  onChange,
}: {
  value: StageSelectTab;
  onChange: (tab: StageSelectTab) => void;
}) {
  return (
    <div className="stage-select-tabs" role="tablist" aria-label="ステージの種類">
      <button
        type="button"
        role="tab"
        aria-selected={value === "catalog"}
        className={`stage-select-tab${value === "catalog" ? " is-on" : ""}`}
        onClick={() => onChange("catalog")}
      >
        公式
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={value === "custom"}
        className={`stage-select-tab${value === "custom" ? " is-on" : ""}`}
        onClick={() => onChange("custom")}
      >
        自作
      </button>
    </div>
  );
}
